<template>
  <div>
    <div class="main-content">
      <div class="row">
        <div class="col-md-12">
          <div class="card">
            <div class="card-body p-1 pb-1">
              <div class="row">
                <div class="col-md-6">
                  <h5>Task nº {{ task.id.toString().padStart(6, "0") }}</h5>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import BaseCrud from "../../layouts/Base/BaseCrud";
import vSelect from "vue-select";

export default {
  name: "imageUpload",
  data() {
    return {
      task: {
        id: 0,
        status: 0,
      },
      status: {
        class: "secondary",
        text: "Carregando...",
      },
      text: "",
      ticketProgress: [],
    };
  },
  computed: {},
  methods: {
    getTask: function (id) {
      const self = this;
      const api = self.$store.state.api + "tasks/" + id + "";

      axios
        .get(api)
        .then((response) => {
          self.task = response.data.data[0];

          switch (self.taks.status) {
            case 1:
              self.status.class = "info";
              self.status.text = "Atendimento";
              self.status.next_class = "primary";
              self.status.next_text = "Homologação";
              break;
            case 2:
              self.status.class = "primary";
              self.status.text = "Homologação";
              self.status.next_class = "return";
              self.status.next_text = "Aguardando Retorno";
              break;
            case 3:
              self.status.class = "return";
              self.status.text = "Aguardando Retorno";
              self.status.next_class = "success";
              self.status.next_text = "Finalizado";
              break;
          }
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
    // getTicket: function() {
    //   const self = this;
    //   const api = self.$store.state.api + "get_ticket/";
    //   let data = {};

    //   data.ticket = self.$route.params.id;
    //   data.user = self.$store.state.user.id;

    //   axios
    //     .post(api, data)
    //     .then(() => {
    //       self.$message(
    //         "Sucesso",
    //         `Chamado atribuído com sucesso`,
    //         "success"
    //       );

    //       self.getTicketProgress(data.ticket);
    //       self.getTask(data.ticket);
    //     })
    //     .catch((error) => {
    //       self.$message(null, error.response.data, "error");
    //     });
    // },
    // saveTicketProgress: function() {
    //   const self = this;
    //   const api = self.$store.state.api + "ticket_progresses/";
    //   let data = {};
    //   data.text   = self.text;
    //   data.status = self.call.status;
    //   data.ticket = self.$route.params.id;

    //   axios
    //     .post(api, data)
    //     .then(() => {
    //       self.$message(
    //         "Sucesso",
    //         `Chamado atribuído com sucesso`,
    //         "success"
    //       );

    //       self.text = "";
    //       self.getTicketProgress(data.ticket);
    //       self.getTask(data.ticket);
    //     })
    //     .catch((error) => {
    //       self.$message(null, error.response.data, "error");
    //     });
    // },
    // getTicketProgress: function(id) {
    //   const self = this;
    //   const api = self.$store.state.api + "ticket_progresses?ticket_id=" + id + "&orderByAsc=next_status";

    //   axios
    //     .get(api)
    //     .then((response) => {
    //       self.ticketProgress = response.data.data;
    //     })
    //     .catch((error) => {
    //       self.$message(null, error.response.data, "error");
    //     });
    // },
  },
  mounted: function () {
    const self = this;
    let id = self.$route.params.id;

    if (id) {
      // self.getTicketProgress(id);
      self.getTask(id);
    }
  },
  components: {
    BaseCrud,
    vSelect,
  },
};
</script>
<style scoped>
.profile_user {
  text-align: center;
}

.photo {
  display: block;
  margin-left: 5px;
  width: 18%;
  border-radius: 10px;
  max-width: 400px;
  max-height: 400px;
  object-fit: cover;
}

.btn-user:hover,
.btn-user[aria-expanded="true"] {
  background: linear-gradient(to right, #000, #666);
  color: #fff !important;
}

.photo-title {
  color: #000;
  font-size: 18px;
  display: block;
  margin-left: 5px;
  width: 18%;
}
.badge-return {
  background: #55aa77 !important;
}

.bg-return {
  background: #55aa77 !important;
}

.font-low {
  font-size: 12px;
}
</style>